import CONSTANTS from './constants';
import getCopy from './copySelector';
var COPY_TYPES = CONSTANTS.COPY_TYPES;
export default {
  COPY_TYPES: COPY_TYPES,
  getCopy: getCopy
};